import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'removeEixo',
})
export class RemoveEixoPipe implements PipeTransform {
  transform(value: any) {
    if (value.startsWith('Eixo')) {
      return value.replace(/Eixo\sd?e?\s?(.*?)/, '$1');
    }
    return value;
  }
}
